import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-payment-services',
  templateUrl: './payment-services.component.html',
  styleUrls: ['./payment-services.component.scss']
})
export class PaymentServicesComponent implements OnInit {

  ngOnInit(): void {
  }
}
